eventDetail = {
  // Nacitanie a zobrazenie Event detailu
  showEventDetail: function(eventID, redirectTo, isRefresh, isResult) {
      try {
        if (more.asideLoading.inProgress) return; // Kontrola ci nie je spustene nejake schvalovanie tiketu
        if (stored.actionsHandling.scrolledByTapAndHold || stored.favoriteBtnTrigger) {
            stored.actionsHandling.scrolledByTapAndHold = false;
            stored.favoriteBtnTrigger = false;
            return false;
        } else if (stored.actionsHandling.tooltipMousedown) {
            stored.actionsHandling.tooltipMousedown = false;
            return false;
        } else if ((stored.FreebetModalActive || stored.JackpotModalActive) || (rfs.jackpotModal && Object.keys(rfs.jackpotModal).length)) {
            // Zamedzenie otvorenia sekcie ak sa ma zobrazit jackpot modalne okno
            return false;
        }
        if (!isRefresh) {
            main.userAction();
        }
        // Skryje informacnu hlasku
        modal.hideInfoModal();

        if (eventID) {
            // Existuje stored.OriginalInputGUID - zobrazenie detailu zapasu kliknutim na zapas v ticket statuse
            if (dialog.isOpen("ticketStatusDialog")) {
                // Ulozi guid tiketu
                if (stored.OriginalInputGUID && stored.OriginalInputTicket.PlaceBetState !== "edited") {
                    stored.tempInputGUID = stored.OriginalInputGUID.toString();
                    stored.OriginalInputGUID = null;
                } else if (stored.OriginalInputCode) {
                    // Najskor sa zistuje ci je otvoreny detail tiketu cez ticketCode aby ulozilo aktualne zobrazenu verziu editovaneho tiketu
                    stored.tempTicketCode = stored.OriginalInputCode.toString();
                    stored.OriginalInputCode = null;
                }
                // Zatvori dialog detailu tiketu, ak je otvoreny po kliknuti na zapas v detaile tiketu
                if (dialog.isOpen("ticketStatusDialog")) dialog.close("ticketStatusDialog");
                switch (redirectTo) {
                    case "sportsBook":
                        stored.redirectTo = "sportsBook";
                        main.setPage(2);
                        break;
                    case "live":
                        stored.redirectTo = "live";
                        main.setPage(3);
                        break;
                    case "results":
                        stored.redirectTo = "results";
                        $('#event').addClass('results');
                        break;
                    default:
                        break;
                }
                // Zastavi pollovanie odkupovej hodnoty tiketu
                if (!stored.PlayerID) {
                    ticketDetail.stopTicketRedeem();
                }
            }
            // Ak sa jedna o detail zapasu vo vysledkovom servise
            if (isResult) {
                $('#event').addClass('results');
            }
            // Ak sa jedna o otvoranie detailu zapasu pocas otvoreneho inline detailu
            if (offer.eventID) {
                var openedEvent = $("#section li#M" + offer.eventID);
                if (openedEvent && openedEvent.hasClass("detail-inline-opened")) {
                    openedEvent.removeClass("detail-inline-opened");
                    openedEvent.find(".event-detail-inline").remove();
                    setTimeout(function() {
                        shared.scrollModule.scrollButtons("table");
                        offer.inlineDetail = false;
                    }, 0);
                }
            }

            var virtualEvent, channel;
            $('#homeTeamButtons, #awayTeamButtons').text('');
            stored.BetRadarStats = new Object({playersHome: [], playersAway: [], playersID: [], statsTypes: []});
            $("#event").removeClass("statsShow");

            // Pri virtualnych hrach prepne video
            if (offer.page != "virtualGames") {

                // Otvori detail eventu
                $("#events").addClass("ui-disabled");
                service.loadPure(isResult? 'resultsEventDetail': 'sportsBookEventDetail', eventID, isRefresh);

            } else if (!(virtualEvent = $("#events #M" + eventID + ".virtual-event")).find(".ui-block-1 a").hasClass("game-ended")) {

                // Zisti poradie bloku detailu zapasu
                var detailBlock;
                if (stored.ExtendedActualOffer) {
                    // Zahrna eventsSexta (okrem viktoriek)
                    if (profile.VirtualsOctava && (offer.regionID === 1239 && offer.provider === offer.providerNameUOF)) {
                        detailBlock = 12;
                    }
                    else if (!offer.eventsVictoria) {
                        detailBlock = 9;
                    } else {
                        detailBlock = 5;
                    }
                } else {
                    detailBlock = 5;
                }

                // Otvori video alebo detail virtualnej hry
                if (!offer.vgL.uofTennis.includes(offer.leagueCupID) && (channel = virtualEvent.find(".ui-block-" + detailBlock + " a")).hasClass("virtual-game-play")) {
                    if (!channel.hasClass("virtual-game-playing")) {
                        $("#events .virtual-event .virtual-game-playing").removeClass("virtual-game-playing");
                        virtualEvent.find(".ui-block-" + detailBlock + " a").addClass("virtual-game-playing");
                        if (virtualEvent !== 'undefined' && virtualEvent != stored.topScreenVgChannel) {
                            stored.topScreenVgVirtualLeague = parseInt(virtualEvent.children("span").attr("id").replace(/\D/g, ''));
                            stored.topScreenVgChannel = parseInt(channel.attr("channel"));
                            communication.topScreen(stored.topScreenActive, {
                                screenShow: true,
                                gameID: offer.regionID,
                                leagueID: stored.topScreenVgVirtualLeague,
                                channelID: stored.topScreenVgChannel
                            });
                        }
                    }
                } else {
                    $("#events").addClass("ui-disabled");
                    service.loadPure(isResult? 'resultsEventDetail': 'sportsBookEventDetail', eventID);
                }
            }
        }
        return true;
    } catch (e) {
        console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        return false;
    }
  },

  // Funkcia na vyrenderovanie hlavicky v detaile zapasu
  eventDetailHeader: function(sportID, sportName, regionID, regionName, leagueCupName) {
    try {
        var e1 = '';
        var e1Length = 0;
        e1 = '<span class="table-icon region_' + regionID + ' sport-icon-' + sportID + ' sport-color-' + sportID + '"></span>';

        // Hlavicku detailu vytvor priamo z response
        e1 += '<span class="table-title-sport">'
            + (sportName && (e1Length += sportName.length) ? sportName : '')
            + (regionName && (e1Length += regionName.length) ? '</span><span class="icon-arrow-right"></span>' + regionName + '</span>' : '')
            + (leagueCupName && (e1Length += leagueCupName.length) ? '<span class="icon-arrow-right"></span>' + leagueCupName + '</span>' : '') + '</hs></span>';
        if (e1Length > 80) {
            e1 = '<hs>' + e1 + '</hs>';
        }
        return e1;
    } catch (e) {
        console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        return '';
    }
  },

  // Funkcia na vyrenderovanie chances v ramci eventu
  eventDetailRender: function(data) {
    try {
        if (data && !data.ErrorType && data.Event && data.EventChanceTypes) {

            if (data.Event.Stream && profile.StreamProviders.includes(data.Event.StreamProvider)) {
                stream.streamSetEventParameters(data.Event.SportID, data.Event.RegionID, data.Event.LeagueCupID, data.Event.EventID);
            } else if (stream.isStreamPlaying) {
                // Hrac klikol na zapas ktory nema streamy, povodny stream sa ukonci
                stream.streamEnd();
            }
            // Prejde na event
            $.mobile.changePage("#event", {"role": "dialog"});

            // Render detailu eventu
            $p("#event #chances").render(data, T.eventDetail);
            $("#event table a.hide-odd").remove();
            $("#event #chances").trigger("create");

            // Oznaci ChanceTypeGroups ak sa otvori novy event
            if (!offer.reloadEvent) {
                if (data.Event.SportID == offer.vgID && !offer.vgL.krnHockey.includes(data.Event.LeagueCupID) && !offer.vgL.uofTennis.includes(data.Event.LeagueCupID) && ![607002, 607003].includes(data.Event.LeagueCupID)) {
                    // VirtualGames, neplati pre vti, Ladovy hokej, KRN PSY, KRN KONE
                    if (offer.vgL.specialDetail.includes(data.Event.LeagueCupID)) {
                        // Virtualne hry so specialnym zobrazenim detailu maju inu ako default aktivnu grupu
                        offer.groupActive = offer.groupSpecialVG;
                    } else {
                        offer.groupActive = offer.groupVG;
                    }
                    if (offer.vgL.evona.includes(data.Event.LeagueCupID)) {
                        // Zavola screensApp s offer datami
                        data.screenShow = true;
                        communication.topScreen("virtualsEvona", data);
                    }
                } else if (data.Event.LiveBetting == "Y") {
                    // Live
                    offer.groupActive = offer.groupLive;
                } else {
                    // Prematch
                    offer.groupActive = offer.groupPrematch;
                }
            }
            if (offer.nextGroupActive) {
                // Nastavi posledny aktivny tab v detaile zapasu
                eventDetail.eventDetailFilter(stored.detailActiveTab? stored.detailActiveTab: offer.nextGroupActive, false, data.ChanceTypeGroups);
                offer.nextGroupActive = null;
            } else {
                eventDetail.eventDetailFilter(stored.detailActiveTab? stored.detailActiveTab: offer.groupActive, false, data.ChanceTypeGroups);
            }

            // Kazdy mousedown v event detaile (okrem vnorenych iframe) bude brat ako akciu uzivatela
            $("#event .ui-content").mousedown(function() {
                main.userAction();
            });

            // Nastavi titulok eventu
            var e1, e2;
            var e1Length = 0;
            if (profile.FlatCSS) {
                // Nastavi nazov hlavicky, ikonu sportu v event detaile (spolu so sipkamy)
                e1 = eventDetail.eventDetailHeader(data.Event.SportID, data.Event.SportName, data.Event.RegionID, data.Event.RegionName, data.Event.LeagueCupName);

                $("#eventTitle").removeAttr("class").html('<span class="table-title">' + e1 + '</span>');
                if ($('#events #section').find('#M' + data.Event.EventID + " .ui-block-1 .ui-icon-main").hasClass('analysis-ico')) {
                    $("#eventHeader #eventAnalysis").addClass("analysis-ico");
                }
                // V event detaile nastavi pozadie podla sportu
                if (data.Event.SportID && data.Event.SportID === offer.vgID) {
                    if (data.Event.RegionID && data.Event.RegionID != -1) {
                        $("#event .ui-bar-c").css("background-image", "url(" + url.assetSport + "backgrounds/wide/sport_" + data.Event.SportID + "_region_" + data.Event.RegionID + ".jpg), " + url.assetSportDefaultBG);
                    } else {
                        $("#event .ui-bar-c").css("background-image", "url(" + url.assetSport + "backgrounds/wide/sport_" + data.Event.SportID + "_purple.jpg), " + url.assetSportDefaultBG);
                    }
                } else {
                    $("#event .ui-bar-c").css("background-image", "url(" + url.assetSport + "backgrounds/wide/sport_" + data.Event.SportID + ".jpg), " + url.assetSportDefaultBG);
                    $("#eventHeader").addClass("with-logo");
                }

                $("#statsBar, #event #h2hButton, #event #homeTeamButton, #event #awayTeamButton, #event #leagueButton, #event #playerButton, #event #playerButtons, #event #betradarStatsWrapper, #event #statsBar, #event #topButtons").hide();
                if (profile.ShowStatistics && (profile.StatisticsParameter === "hasBetradarHostedStatistics") && data?.Event?.SportID !== offer.vgID) {
                    stored.statsAreShown = false;
                    var statsTypesCount = 0;
                    var statsGridClass = "";
                    if (data.Event.BetradarStatisticsUrl) stored.BetRadarStats.betradarStatisticsUrl = data.Event.BetradarStatisticsUrl;
                    if (data.Event.BetradarSportID) stored.BetRadarStats.betRadarSportID = data.Event.BetradarSportID;
                    if (data.Event.Widgets.includes("statistics") && stored.BetRadarStats.betRadarSportID && stored.BetRadarStats.statsTypes &&
                        (data.Event.SeasonID || data.Event.BetradarStatisticsUrl && data.Event.BetradarStatisticsUrn)) {
                        var statsEventID = data.Event.PrematchEventID ? data.Event.PrematchEventID : data.Event.EventID;
                        if (statsEventID) {
                            stored.BetRadarStats.statsTypes.push("h2h");
                            // H2H format: https://s5.sir.sportradar.com/doxxbetm/sk/match/m14482228
                            $("#event #statsButtons #h2hButton")
                                .attr("onmousedown", "eventDetail.eventDetailStats('" + stored.BetRadarStats.betradarStatisticsUrl + "', 'h2h', " + statsEventID + ")")
                                .show();
                        }
                        if (data.BetradarTeams.home) stored.BetRadarStats.statsTypes.push("homeTeam");
                        if (data.BetradarTeams.away) stored.BetRadarStats.statsTypes.push("awayTeam");
                        if (data.Event.SeasonID) stored.BetRadarStats.statsTypes.push("league");
                        if (stored.BetRadarStats.playersID.length) stored.BetRadarStats.statsTypes.push("player");

                        var statsTypesCount = stored.BetRadarStats.statsTypes.length;
                        if (statsTypesCount <= 2) statsGridClass = "a";
                        else if (statsTypesCount === 3) statsGridClass = "b";
                        else if (statsTypesCount === 4) statsGridClass = "c";
                        else statsGridClass = "d";

                        // Nastavi grid pre tlacidla statistik
                        $("#event #statsButtons").removeClass().addClass("ui-grid-" + statsGridClass);

                        // Zobrazi jednotlive tlacidla pre rozne typy statistik
                        if (stored.BetRadarStats.statsTypes.includes("homeTeam")) {
                            // Domaci tim
                            $("#event #statsButtons #homeTeamButton a").text(data.Event.EventNames[0]).parent()
                                .attr("onmousedown", "eventDetail.eventDetailStats(" + stored.BetRadarStats.betRadarSportID + ", 'teamHome', " + data.Event.SeasonID + ", " + data.BetradarTeams.home + ")")
                                .show();
                        }
                        if (stored.BetRadarStats.statsTypes.includes("awayTeam")) {
                            // Hostujuci tim
                            $("#event #statsButtons #awayTeamButton a").text(data.Event.EventNames[1]).parent()
                                .attr("onmousedown", "eventDetail.eventDetailStats(" + stored.BetRadarStats.betRadarSportID + ", 'teamAway', " + data.Event.SeasonID + ", null, " + data.BetradarTeams.away + ")")
                                .show();
                        }
                        if (stored.BetRadarStats.statsTypes.includes("league")) {
                            // Liga
                            $("#event #statsButtons #leagueButton")
                                .attr("onmousedown", "eventDetail.eventDetailStats(" + stored.BetRadarStats.betRadarSportID + ", 'league', " + data.Event.SeasonID + ")")
                                .show();
                        }
                        if (stored.BetRadarStats.playersID.length) {
                            // Hraci
                            if (stored.BetRadarStats.playersHome && stored.BetRadarStats.playersHome.length) {
                                var playerHomeButtons = "";
                                var blockIndex = 0;
                                for (playerHomeIndex = 0; playerHomeIndex <= stored.BetRadarStats.playersHome.length - 1; playerHomeIndex++) {
                                    if ((playerHomeIndex) % 3 === 0) blockIndex = 1;
                                    playerHomeButtons += "<div id='player-"
                                        + stored.BetRadarStats.playersHome[playerHomeIndex].betRadarPlayerID + "' onmousedown = 'eventDetail.eventDetailStats("
                                        + stored.BetRadarStats.betRadarSportID + ", \"player\", "
                                        + stored.BetRadarStats.playersHome[playerHomeIndex].seasonID + ", "
                                        + stored.BetRadarStats.playersHome[playerHomeIndex].teamID + ", null, "
                                        + stored.BetRadarStats.playersHome[playerHomeIndex].betRadarPlayerID + ")' class='stats-player-button ui-block-"
                                        + blockIndex + "'><img src='" + url.assetTeam + data.BetradarTeams.home + ".png' onerror='eventDetail.eventLogoError(this);'><a class='player-name'>"
                                        + stored.BetRadarStats.playersHome[playerHomeIndex].playerName + "</a></div>";
                                    blockIndex++;
                                }
                                $('#homeTeamButtons').append(playerHomeButtons);
                            }
                            if (stored.BetRadarStats.playersAway && stored.BetRadarStats.playersAway.length) {
                                var playerAwayButtons = "";
                                var blockIndex = 0;
                                for (playerAwayIndex = 0; playerAwayIndex <= stored.BetRadarStats.playersAway.length - 1; playerAwayIndex++) {
                                    if ((playerAwayIndex) % 3 === 0) blockIndex = 1;
                                    playerAwayButtons += "<div id='player-"
                                        + stored.BetRadarStats.playersAway[playerAwayIndex].betRadarPlayerID + "' onmousedown = 'eventDetail.eventDetailStats("
                                        + stored.BetRadarStats.betRadarSportID + ", \"player\", "
                                        + stored.BetRadarStats.playersAway[playerAwayIndex].seasonID + ", "
                                        + stored.BetRadarStats.playersAway[playerAwayIndex].teamID + ", null, "
                                        + stored.BetRadarStats.playersAway[playerAwayIndex].betRadarPlayerID + ")' class='stats-player-button ui-block-"
                                        + blockIndex + "'><img src='" + url.assetTeam + data.BetradarTeams.away + ".png' onerror='eventDetail.eventLogoError(this);'><a class='player-name'>"
                                        + stored.BetRadarStats.playersAway[playerAwayIndex].playerName + "</a></div>";
                                    blockIndex++;
                                }
                                $('#awayTeamButtons').append(playerAwayButtons);
                            }
                            $('#betradarStatsWrapper').height(839 - $('#playerButtons').height());
                            $("#event #statsButtons #playerButton").attr("onmousedown", "eventDetail.eventDetailStats(" + true + ", 'player')").show();
                        }

                        var firstOrderStats = $("#event #" + stored.BetRadarStats.statsTypes[0] + "Button").attr("onmousedown");
                        // Nastavi a zobrazi tlacidlo "Statistiky"
                        $("#event #topButtons #stats").removeClass('active').attr("onmousedown", firstOrderStats).parent().show();
                        var ratesButton = $("#event #topButtons #rates");
                        if (data.IsResult || stored.redirectTo === "results") {
                            // Nastavi tlacidlo "Vysledky"
                            $(ratesButton).html(texts.EventHeaderResults);
                            $('#event .chances a').removeAttr('onclick');
                        } else {
                            // Nastavi tlacidlo "Kurzy"
                            $(ratesButton).html(texts.EventHeaderRates);
                        }
                        $(ratesButton).attr("onmousedown", "eventDetail.eventDetailStats(false);").addClass("active");
                    }
                    if (data.IsResult || stored.redirectTo === "results") {
                        $('#event .chances a').removeAttr('onclick');
                    }
                }
                if (stored.BetRadarStats.statsTypes && stored.BetRadarStats.statsTypes.length) {
                    // Pripade ze existuje aspon jeden typ statistik, zobrazi prepinac statistik a kurzov
                    $("#event #topButtons").show();
                }
            } else {
                $("#event #statsBar, #event #topButtons").hide();
                e1 = $("#tableTop .table-title").text();
                if (offer.page != "popularLeagues") {
                    e2 = e1;
                    e1 = $("#offerTop").text();
                }
                if (e2 && e2 != e1) e1 = e1 + " - " + e2;
                // Ak je titulok prilis dlhy tak zmensi font pisma, pripadne odsekne
                if (e1.length < 65) {
                    $("#eventTitle").removeAttr("class").text(e1);
                } else {
                    $("#eventTitle").addClass("long-title").text(e1);
                }
            }

            // Zvyrazni neparne chancetypes oddu
            if (data.Match) {
                for (o = 1; o < data.Match.length; o += 2) $("#event .chance").eq(o).addClass("event-odd");
            }

            if (offer.eventLive === "Y") {
                eventDetail.detailShowAnotherTabButton();
            }

            // [Betbuilder Aggregator API] - inicializuje BetBuilder Aggregator ak event obsahuje BetBuilder a je povoleny v profile
            if (profile.BetBuilderAgg && data.Event.Widgets.includes("betbuilder")) {
                // Pre citatelnost nedavam vsetky podmienky do jedneho if-u
                if (offer.eventLive === "Y") {
                    // Event je LIVE event a je povoleny Betbuilder a Betbuilder pre LIVE
                    if (profile.BetBuilderAggLive) betbuilderAgg.init(data.Event.EventID);
                } else {
                    // Event nie je LIVE event a je povoleny Betbuilder
                    betbuilderAgg.init(data.Event.EventID);
                }
            }
            
            $("#events").removeClass("ui-disabled");
            return true;

        } else {
            if (profile.Results && stored.tempInputGUID && offer.eventID && (stored.redirectTo !== "results")) {
                // Ak nieje detail zapasu, pokusi sa ziskat vysledky pre dany zapas
                stored.redirectTo = "results";
                eventDetail.showEventDetail(offer.eventID, "results");
            } else {
                // Nedostupne presmerovanie na detail zapasu
                if (stored.tempInputGUID) {
                    stored.OriginalInputGUID = stored.tempInputGUID.toString();
                    stored.tempInputGUID = null;
                    stored.redirectTo = "";
                }
                modal.showErrObj(1, 5, {err1: texts.OfferNoEvent, errType: "OfferNoEvent"});
            }
            $("#events").removeClass("ui-disabled");
            return false;
        }
    } catch (e) {
        console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        $("#events").removeClass("ui-disabled");
        modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
        return false;
    }
  },

  // Funkcia na zobrazenie default loga teamu v event detaile (FLAT)
  eventLogoError: function(img, empty) {
    img.onerror = null;
    if (!empty) {
        img.src = url.assetTeam + '0.png';
    } else {
        img.src = url.base + 'stylesheets/images/emptySmall.png';
    }
    return true;
  },

  // Nacitanie a zobrazenie Event detailu v plachte pod zapasom
  eventDetailStats: function(betRadarSportIDshow, statsType, betRadarSessionID, betRadarTeamHomeID, betRadarTeamAwayID, betRadarPlayerID) {
    try {
        // tap & posun na buttone statistik hraca, na buttone ligovych statistik v ponuke
        if (stored.actionsHandling.scrolledByTapAndHold && ((statsType == "player" && betRadarPlayerID) || (statsType == "leagueFromOffer"))) {
            event.stopPropagation();
            stored.actionsHandling.scrolledByTapAndHold = false;
            return false;
        }

        if (!stored.statsAreShown) {
            // Otvorenie statistik skryva pripadne otvoreny tooltip
            modal.hideTooltip();
            stored.statsAreShown = true;
            $('#event .chances, #event #eventHeader').hide();
            $('#event #rates').removeClass('active');
            $('#event #stats').addClass('active');
            $('#event #betradarStatsWrapper').show();
            if (!$("#betRadarStatsScrollable #sr-iframe")[0] && SportradarIframeAPI) {
                $("#betRadarStatsScrollable").append('<iframe id="sr-iframe" frameborder="0" scrolling="no" style="height:5000px;margin-top:-160px;"></iframe>');
                SportradarIframeAPI.init($('#sr-iframe')[0]);
            }
        }

        if (!betRadarSportIDshow) {
            $('#event #statsBar, #event #playerButtons').hide();
            $('#event #stats').removeClass('active');
            $('#event #rates').addClass('active');

            // Zrusi iframe url, skryje iframe wrapper
            $('#event #betradarStatsWrapper').hide();
            // Nastavi skrolovnanie detail zapasu - kurzy
            // Nastavi zobrazenie pre okno detailu zapasu - KURZY
            stored.statsAreShown = false;
            $('#event .chances, #event #eventHeader').show();
            $('#event').removeClass('statsShow');
            setTimeout(function () {
                shared.scrollModule.scrollButtons("event");
            }, 0);
        } else {
            // Nastavi zobrazenie pre okno detailu zapasu - STATISTIKY
            stored.statsAreShown = true;
            var statsUrl = url.betRadarStats + offer.lang + "/" + betRadarSportIDshow;
            $('#event #statsBar #h2hButton, #event #statsBar #homeTeamButton, #event #awayTeamButton, #event #leagueButton, #event #playerButton').removeClass('active');
            $('#event #statsBar').show();
            $('#event').addClass('statsShow');

            switch (statsType) {
                case "league":
                case "leagueFromOffer":
                    $("#event #playerButtons").hide();
                    $('#event #statsBar #leagueButton').addClass('active');
                    statsUrl = statsUrl + '/season/' + betRadarSessionID;
                    if (statsType === "league") break;

                    // Pripravi zobrazenie pre ligove tabulky v upravenom okne ED
                    $.mobile.changePage("#event", {
                        "role": "dialog"
                    });
                    main.dialogOpen("event");
                    $('#event').addClass('league-table');
                    $('#event .chances, #event #eventHeader, #event #topButtons').hide();
                    $('#event #statsBar').hide();
                    var elemParent = $(event.currentTarget.parentElement);
                    var elemChild = $(elemParent).find('.label-main');

                    var modalLabel = '<span class="league-label">' + texts.EventHeaderLeagueTable + '</span>' +
                        '<span class="table-icon region_' +
                        elemParent.attr('region-id') + ' sport-icon-' +
                        elemParent.attr('sport-id').substr(2) + ' sport-color-' +
                        elemParent.attr('sport-id').substr(2) + '"></span><hs><span class="table-title-sport">' +
                        elemChild.attr('sport-name') + '</span><span class="icon-arrow-right"></span>' +
                        elemChild.attr('region-name') + '<span class="icon-arrow-right"></span>' +
                        elemChild.attr('leaguecup-name') + '</hs>';

                    $('#event #eventTitle').html(modalLabel);
                    break;
                case "teamHome":
                    $("#event #playerButtons").hide();
                    $('#event #statsBar #homeTeamButton').addClass('active');
                    statsUrl = statsUrl + '/season/' + betRadarSessionID + '/team/' + betRadarTeamHomeID;
                    break;
                case "teamAway":
                    $("#event #playerButtons").hide();
                    $('#event #statsBar #awayTeamButton').addClass('active');
                    statsUrl = statsUrl + '/season/' + betRadarSessionID + '/team/' + betRadarTeamAwayID;
                    break;
                case "player":
                    if (betRadarPlayerID) {
                        // Zabranenie pridania oddu na tiket
                        event.stopPropagation();
                        if (betRadarSessionID && betRadarTeamHomeID) {
                            statsUrl = statsUrl + '/season/' + betRadarSessionID + '/team/' + betRadarTeamHomeID + '/player/' + betRadarPlayerID;
                        } else {
                            statsUrl = statsUrl + '/player/' + betRadarPlayerID;
                        }
                        $('#event #statsBar #playerButton').addClass('active');
                    } else {
                        // Zobraz panel s hracmi
                        if ($("#event #playerButtons").is(":hidden")) {
                            $("#event #playerButtons").show();
                            $('#event #statsBar #playerButton').addClass('active');
                            statsUrl = false;
                        } else {
                            $('#event #playerButton').addClass('active');
                            $('#betRadarStatsScrollable').scrollTop(0);
                            return true;
                        }
                    }
                    $("#event #playerButtons").show();
                    setTimeout(function () {
                        $('#event #playerButtons').find('.active').each(function (p, playerBtn) {
                            $(playerBtn).removeClass('active');
                        });
                        $('#event #player-' + betRadarPlayerID).addClass('active');
                    }, 0);

                    break;
                case "h2h":
                default:
                    $("#event #playerButtons").hide();
                    $('#event #statsBar #h2hButton').addClass('active');
                    // V pripade h2h statistik plati ze v betRadarSportIDshow je hodnota parametra stored.BetRadarStats.betradarStatisticsUrl
                    statsUrl = url.betRadarStats + offer.lang + "/" + betRadarSportIDshow;
                    break;
            }
            if (statsUrl) {
                setTimeout(function () {
                    var statsEmptyAreaHeight = 0;
                    var statsWrapperHeight = 839;
                    // Nastavi iframe url pre statistiky
                    SportradarIframeAPI.update($("#sr-iframe")[0], {
                        url: statsUrl
                    });
                    shared.scrollModule.scrollButtons("event-stats", -1);
                    $('#betRadarStatsScrollable').scrollTop(0);
                    // Ak su ligove tabulky otvorene z ponuky, zatvori ligovu tabulku na vrchnej obrazovke
                    if (statsType === "leagueFromOffer") communication.statsTable(false)
                    else statsEmptyAreaHeight = 60;
                    $('#statsEmptyArea').height(statsEmptyAreaHeight);
                    $('#betradarStatsWrapper').height(statsWrapperHeight);
                }, 0);
            } else {
                // Kliknutie na Hracov - zaskroluje statistiky nahor
                $('#betRadarStatsScrollable').scrollTop(0);
            }
        }
    } catch (e) {
        console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
    }
  },

  // Funkcia zobrazuje/skryva tlacidlo pre zobrazenie inej skupiny-tabu v detaile zapasu (LIVE)
  detailShowAnotherTabButton: function() {
    $("#event #showAllChances, #event #liveButtonNotice").hide();
    if (offer.groupActive !== 'allLocked') {
        if (eventDetail.edNumberAllECT() === 0) {
            // V aktualne aktivnej skupine sa nenachadza aktivna paramGroup/ECT (neprazdne paramGroups s aktivnymi ECT + aktivne ECT)
            $("#event #liveButtonNotice").text(texts.OfferGroupTabNonAvailable).show();
        } else if ($("#event .chances").hasClass("event-suspended")) {
            // Uzamknuty cely zapas
            $("#event #liveButtonNotice").text(texts.OfferGroupBetsNonAvailable).show();
        }
    }
    shared.scrollModule.scrollButtons("event", (profile.Resolution === "1280x1024"? 392: null));
  },

  // Funkcia na filtrovanie chanceTypes v ramci eventu
  eventDetailFilter: function(groupActive, scroll, groups) {
    try {
        // [Betbuilder Aggregator API] Deaktivácia BetBuilder pri prepnutí na iný tab
        if (offer.groupActive === "betbuilder-agg" && groupActive !== "betbuilder-agg") {
            betbuilderAgg.deactivate();
        }
        $("#event #liveButtonNotice").hide();
        if (offer.groupActive && groupActive && groupActive !== offer.groupActive) {
            // Suspendovane oddy ktore sa maju vymazat pri prekliknuti do ineho tabu
            $('#event #chances a[visibility="oddToHide"]').removeAttr('visibility').attr('odd-visibility', 'hidden');
        }
        if (scroll) shared.scrollModule.scrollPage('event', 'top');
        // Prepnutie tabu v detaile zapasu zrusi pripadne otvoreny tooltip
        modal.hideTooltip();
        if (groups) offer.groups = groups;
        if (offer.groups) {
            $("#event #chanceGroups").addClass("lock-btn");
            $("#event #chances").removeClass();

            if (groupActive === stored.eventNews) {
                // Skryje promo baner
                $('#detailBanner, #chanceGroups .promo-dot').hide();
            } else if (stored.eventNews) {
                // Zobrazi promo baner
                $('#detailBanner, #chanceGroups .promo-dot').show();
            }

            if (groupActive && groupActive != "default") {
                $("#event #chances").addClass(groupActive);

                // Zobrazi prilezitosti danej skupiny
                var selectedGroup = false;
                $("#event").removeClass("chanceType-showAll");
                if (groupActive == "allLocked") {
                    selectedGroup = true;
                    $("#event #liveButtonNotice").hide();
                    $("#event").addClass("chanceType-showLocked");
                } else {
                    $("#event").removeClass("chanceType-showLocked");
                }
                $("#event .chances .chanceType-suspended").addClass("chanceType-hidden");
                if (groupActive == "allActive") {
                    // Zobrazenie aktivnych
                    if (offer.groups && offer.groups.some(function(group){return group.ChanceTypeGroupID === "allActive"})) {
                        // Ak skupina "allActive" existuje, zobrazi ju
                        selectedGroup = true;
                        $("#event .chances .chance").removeClass("filtered").closest(".chancegroup").removeClass("filtered");
                    } else {
                        // Ak skupina "allActive" neexistuje zobrazi "top"
                        eventDetail.eventDetailFilter("top");
                        return true;
                    }
                } else {
                    if (groupActive == "betbuilder-agg") {
                        // [Betbuilder Aggregator API]
                        betbuilderAgg.init(offer.eventID, true);
                    }
                    $.each(offer.groups, function (g, group) {
                        if (group.ChanceTypeGroupID == groupActive) {
                            selectedGroup = true;
                            if (groupActive !== "allLocked" && groupActive !== "betbuilder-agg") {
                                $("#event #showAllChances").hide();
                                // Vyfiltruje prilezitosti ktore maju ostat zobrazene
                                $("#event .chances .chance").addClass("filtered").closest(".chancegroup").addClass("filtered");
                                $.each(group.ChanceTypes, function (c, chanceType) {
                                    $("#event .chances .chance[chanceType-id='" + chanceType + "']").removeClass("filtered").closest(".chancegroup").removeClass("filtered");
                                });
                            } else {
                                // Pre tab 'Zamknute' a 'Betbuilder' [Betbuilder Aggregator API] odobere 'filtered' takze vsetky paramGroups a ECT su nevyfiltrovane
                                $("#event .chances .chance").removeClass("filtered").closest(".chancegroup").removeClass("filtered");
                            }
                        }
                    });
                }
                // Ak nenasiel danu skupinu alebo v nej nie je ani jedna aktivna prilezitost tak zrusi filter udalosti
                if (!selectedGroup) {
                    eventDetail.eventDetailFilter(false);
                } else {
                    offer.groupActive = groupActive;
                    // Oznaci tlacidlo daneho filtra
                    $("#event #chanceGroups .ui-btn-active").removeClass("ui-btn-active lock-btn");
                    $("#event #chanceGroups #group-" + groupActive + " a").addClass("ui-btn-active lock-btn");
                    $("#event #chanceGroups").removeAttr("class");
                    setTimeout(function () {
                        if (groupActive !== "betbuilder" && (offer.eventLive !== "Y" || offer.sportID === offer.vgID)) {
                            if ($("#event .chances .chance").length == $("#event .chances")
                            .find(".chanceType-active.filtered, .chanceType-suspended.filtered, .chanceType-hidden").length)
                            eventDetail.eventDetailFilter(false);
                        } else if (groupActive !== "betbuilder") {
                            eventDetail.detailShowAnotherTabButton(groupActive);
                        }
                    }, 200);
                }
                // Zobrazovat pre vsetky kategorie okrem Vsetko a betbuilder
                if (groupActive !== "betbuilder" && offer.page !== "results" && stored.redirectTo !== "results" && offer.eventLive !== "Y" && offer.groups[0].ChanceTypeGroupID !== "default-special") {
                    $("#event #showAllChances").show().find(".ui-btn-text").text(texts.OfferGroupAll);
                } else if (offer.groups.length && offer.groups[0].ChanceTypeGroupID === "default-special") {
                    $("#event").addClass("overall-event");
                }
            } else {
                if (offer.eventLive == "Y" && offer.sportID !== offer.vgID) {
                    $("#event").addClass("chanceType-showLocked").removeClass("chanceType-showAll");
                    $("#event .chances .chance").removeClass("filtered").closest(".chancegroup").removeClass("filtered");
                    $("#event #chanceGroups .ui-btn-active").removeClass("ui-btn-active lock-btn");
                    $("#event #chanceGroups #group-allLocked a").addClass("ui-btn-active lock-btn");
                    $("#event #chanceGroups").removeAttr("class");
                } else {
                    $("#event #chances").addClass(groupActive);

                    // Zobrazi vsetky prilezitosti
                    offer.groupActive = "default";
                    $("#event #showAllChances").hide();
                    $("#event").removeClass("chanceType-showLocked").addClass("chanceType-showAll");
                    $("#event .chances .chance").removeClass("filtered").closest(".chancegroup").removeClass("filtered");
                    $("#event #chanceGroups .ui-btn-active").removeClass("ui-btn-active lock-btn");
                    $("#event #chanceGroups #group-default a").addClass("ui-btn-active lock-btn");
                    $("#event #chanceGroups").removeAttr("class");
                }
            }
            stored.detailActiveTab = false;
            if (profile.FlatCSS) {
                shared.scrollModule.scrollButtons("event", (profile.Resolution === "1280x1024"? 392: null));
                // Pri scrole v detaile zapasu skryje otvoreny tooltip
                var detailScrollableElem = $._data($('.chances')[0], "events");
                if (!detailScrollableElem) {
                    $("#event .chances").scroll(function() {
                        modal.hideTooltip();
                    });
                }
            } else {
                // Ak je pocet chancetyp kratky tak sa tlacitka na posun disabluju
                if ($("#event .chances").height() < 650) {
                    $("#event .arrows").addClass("ui-disabled");
                    $("#event #showAllChances").removeClass("scrollbar");
                } else {
                    $("#event .arrows").removeClass("ui-disabled");
                    $("#event #showAllChances").addClass("scrollbar");
                }
            }
            return true;
        } else {
            return false;
        }
    } catch (e) {
        console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        $("#event #chanceGroups").removeAttr("class");
        return false;
    }
  },

  // Funkcia vrati rozdiel medzi suctom vsetkych ECT a suspendovanych/skrytych ECT
  edNumberAllECT: function() {
    return $("#event .chances div.chance, #event .chances .chancegroup tr.chance").length - $("#event .chances").find(".chance.filtered, .chance.chanceType-suspended, .chance.chanceType-hidden").length;
  },

  // Funkcia na zaklade stavu oddov zobrazuje pripadne vymazava ECT
  eCTVisible: function(chType) {
    var visibleOdds = chType.find('a[odd-visibility="showed"], a[odd-visibility="locked"]');
    if (visibleOdds && visibleOdds.length) {
        // ECT obsahuje aspon jeden locked alebo showed odd
        chType.addClass('chanceType-active').removeClass('chanceType-suspended chanceType-hidden');
        return true;
    }
    // Vymaze ECT (ECT neobsahuje aspon jeden locked alebo showed odd)
    chType.remove();
    return false;
  },

  // Funkcia na zaklade stavu ECT zobrazuje pripadne vymazava parametricku skupinu
  paramGroupVisible: function(group) {
    var isGroupEmpty = true;
    // Prechadza kazdu chancetype v danej skupine
    group.find('.chance').each(function(c, chType) {
        if (eventDetail.eCTVisible($(chType))) {
            // Zobrazi skupinu
            group.removeClass('chancegroup-is-empty').addClass('chancegroup-is-not-empty');
            isGroupEmpty = false;
            return false;
        }
    });
    if (isGroupEmpty) {
        // Vymaze skupinu (ani 1 ECT v skupine nieje viditelna)
        // group.removeClass('chancegroup-is-not-empty').addClass('chancegroup-is-empty');
        group.remove();
        return false;
    }
  },

  // Funckia na parsovanie casu vzhladom na sport
  parseGamePart: function(sportID, gamePartID, gamePartTime, eventDate, eventID) {
    try {
        var gamePart = new Object();
        // Upravi sportID o uroven nizsie pre VG
        if (sportID == offer.vgID) sportID = offer.regionID;
        // Nastavi preklad gameParty, nastavi nonstarted namiesto notstarted pre sporty kde sa jedna o preteky
        if (gamePartID == "notstarted" && offer.sportID !== offer.vgID && eventDate && ((diff = (today.getTime() - new Date(eventDate).getTime())/1000) && diff < 0)) {
            // Prekreslovanie informacie o zaciatku zapasu
            gamePart.Label = texts.EventStarting + " " + Math.ceil(Math.abs(diff) / 60) + " min.";
            clearTimeout(rfs.LiveListCountDown["eventCountDown-" + eventID]);
            rfs.LiveListCountDown["eventCountDown-" + eventID] = setTimeout(function() {
                $("#events #M" + eventID + " .ui-block-1 .ui-li-desc").html(eventDetail.parseGamePart(sportID, gamePartID, gamePartTime, eventDate, eventID).Label);
            }, 2000);
        } else if (gamePartID == "notstarted" && offer.vgL.racing.includes(sportID)) {
            gamePart.Label = (offer.offerGameParts? stored.GameParts["nonstarted"].Name : texts["GamePart-nonstarted"]);
        } else {
            if (offer.sportID === offer.vgID && gamePartID == "notstarted") {
                gamePart.Label = stored.GameParts.started.Name;
            } else {
                gamePart.Label = (offer.offerGameParts? stored.GameParts[gamePartID].Name : texts["GamePart-" + gamePartID]);
            }
        }
        if (!gamePart.Label) gamePart.Label = "&nbsp;";

        // Nastavi cas podla sportu
        if (gamePartTime && gamePartTime != -1) {
            gamePart.Time = gamePartTime;
            gamePart.Time += "'&nbsp; ";
        } else {
            gamePart.Time = "";
        }
        return gamePart;
    } catch (e) {
        console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        return false;
    }
  },

  // Funkcia vrati score elementy potrebne na render do plachty
  prepareScoreForRender: function(parsedScore) {
    try {
        var scoreElements = "<span class='total-result'>" + parsedScore.total + "</span>";
        if (parsedScore.partially) {
            scoreElements += "<span class='parcial-result'>(" + parsedScore.partially[parsedScore.partially.length - 1] + ")</span>";
        }
        if (parsedScore.game) {
            scoreElements += "<span class='game-score " + (parsedScore.service? parsedScore.service : "") + "'>" + parsedScore.game + "</span>";
        }
        return scoreElements;
    } catch (e) {
        console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        return false;
    }
  },

  // Funkcia na parsovanie event detailu (LIVE / next LIVE / Prematch)
  parseEvent: function(liveFeedReference, liveBetting, sportID, gamePartID, gamePartTime, eventDate, eventID) {
    try {
        if (eventDate) {

            var event = new Object();
            event.EventDateRaw = eventDate;
            event.EventDate = eventDate.substr(8, 2) + "." + eventDate.substr(5, 2) + "." + eventDate.substr(0, 4) + " " + eventDate.substr(11, 5);
            event.Time = eventDate.substr(11, 5);
            event.Label = "";

            // Pri prematch udalostiach porovna ci ma zobrazit ako nextLive
            if (liveFeedReference > 0 && offer.dateTD == eventDate.substr(0, 10) && (offer.actualHour + offer.nextLive) >= eventDate.substr(11, 2))
                event.NextLive = true;

            if (event.NextLive || liveBetting == "Y") {
                // LIVE & next LIVE
                event.Date = texts.MarkLive;
                // Zobrazi gamePartu ak sa jedna o LIVE pripadne beziace VirtualGames
                if (liveBetting == "Y" && (sportID != offer.vgID || !["notstarted", "nonstarted"].includes(gamePartID))) {
                    // LIVE
                    var live = eventDetail.parseGamePart(sportID, gamePartID, gamePartTime, eventDate, eventID);
                    event.Time = live.Time;
                    event.Label = live.Label;
                }
            } else if (event.Date = eventDate.substr(0, 10)) {
                // Prematch (Dnes / Zajtra / Datum)
                if (event.Date == offer.dateTD) {
                    // Dnes
                    event.Date = texts.OfferTD;
                } else if (event.Date == offer.dateTM) {
                    // Zajtra
                    event.Date = texts.OfferTM;
                } else {
                    // Datum
                    event.Date = event.Date.substr(8, 2) + "." + event.Date.substr(5, 2);
                }
            }
            return event;

        } else {
            return false;
        }
    } catch (e) {
        console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        return false;
    }
  },

  // Funkcia na stopnutie refreshu eventu
  closeEvent: function() {
    try {
        // Odstrani otvoreny event z html
        if ((openedEvent = $("#section li#M" + offer.eventID)) && openedEvent.hasClass("detail-inline-opened")) {
            // Ak je otvoreny inline detail
            openedEvent.removeClass("detail-inline-opened");
            openedEvent.find(".event-detail-inline").remove();
            offer.inlineDetail = false;
            setTimeout(function() {
                shared.scrollModule.scrollButtons("table");
            }, 0);
        }

        offer.eventID = offer.eventLive = offer.reloadEvent = offer.groups = offer.groupActive = offer.eventLeagueCupID = offer.nextGroupActive = stored.eventNews = null;
        if (!(offer.page === "results" || stored.redirectTo === "results")) {
            events.eventsSignalrModule.setSignalR();
        }
        stored.BetRadarStats = new Object();
        $("#homeTeamButtons, #awayTeamButtons, #homeTeamButton a, #awayTeamButton a").text("");
        $("#event").removeClass("league-table overall-event results");
        $("#event .chances, #event #eventHeader").show();

        // Zrusi pripadne otvoreny tooltip
        modal.hideTooltip();

        // [Betbuilder Aggregator API] Zrusi pripadne aktivny betbuilder;
        if (profile.BetBuilderAgg && typeof betbuilderAgg !== "undefined") {
            betbuilderAgg.destroy();
        }

        setTimeout(function () {
            // Zrusi iframe pre statistiky
            if ($("#betRadarStatsScrollable #sr-iframe")[0]) {
                SportradarIframeAPI.destroy($("#sr-iframe")[0]);
                $('#event #betradarStatsWrapper').hide();
                stored.statsAreShown = false;
            }
            $("#statsButtons div, #topButtons #rates").removeAttr("onmousedown");
            $("#eventTitle, #matchTrackerControlPanelInner").empty();
            var detailBanner = $("#detailBanner").removeAttr("onmousedown").children().text('').parent().hide();
            $("#event #chances").html("");
            $("<div id='chances'></div>" ).insertAfter("#eventTop").append(detailBanner);

        }, 100);
        communication.statsTable(true);

        return true;
    } catch (e) {
        console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        return false;
    }
  },

  // Funkcia ktora pri pridani oddu rozhodne ci ma alebo nema zatvorit event okno
  autoCloseEvent: function(betType) {
    try {
        // Ak nenastane ani jedna z uvedenych poziadaviek tak sa event okno zatvori
        if (offer.eventID && (offer.sportID != offer.vgID && !(offer.eventLive == "Y" || betType == "VICTORIA_COMPETITOR" || betType == "VICTORIA_PLAYER"))) main.closeDialog();
        return true;
    } catch (e) {
        console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
        return false;
    }
  },

  // Funkcia na renderovanie skore v eventDetaile
  eventScoreTable: function(score, sportID, regionID, part) {
    if (part == "scoreHeader") {
        if (score && score.Home && score.Away) {
            var parcialHeader = "";
            var partHeaderIndex = 0;

            if (score.Home.partially) {
                $.each(score.partially, function () {
                    // Pre kazde parcialne skore (v riadnom hrac. case) vypise poradie parcialnej casti hry (1., 2., ...)
                    partHeaderIndex++;
                    parcialHeader += "<span class='partial score-head-part-" + partHeaderIndex + "'>" + partHeaderIndex + ".</span>";
                });
            }

            // Prida skore pocas predlzenia
            if (score.overtime) {
                $.each(score.overtime, function (i, partially) {
                    parcialHeader += "<span class='score overtime score-part-" + (++partHeaderIndex) + "'>" + texts.EventScoreOverTimeShortcut + "</span>";
                });
            }

            // Ak boli penalty (penalties) prida hlavicku 'P'
            if (score.penalties) {
                parcialHeader += "<span class='penalties score-head-part-" + (++partHeaderIndex) + "'>" + texts.EventScorePenaltyShortcut + "</span>";
            }

            // Prida do hlavicky zltu a cervenu kartu (pri futbale zobrazuje karty vzdy )
            if (sportID == "54" || score.cardsYellow) parcialHeader += "<span class='score-head-part-" + (++partHeaderIndex) + "'><div class='yellow-card'></div></span>";
            if (sportID == "54" || score.cardsRed) parcialHeader += "<span class='score-head-part-" + (++partHeaderIndex) + "'><div class='red-card'></div></span>";
            if (sportID == "54" || score.corners) parcialHeader += "<span class='score-head-part-" + (++partHeaderIndex) + "'><div class='icon-corner'></div></span>";

            return parcialHeader;
        }
    }
    if (part == "scoreHome") {
        if (score && score.Home) {
            var parcialH = "";
            var partHomeIndex = 0;

            if (score.Home.service) {
                // Prida ikonu ak je aktualne na podani domaci team
                parcialH += "<span class='score main-icon ui-icon-sports show-icon sport-icon-" + sportID + " sport-" + sportID + " region-" + regionID + "'></span>";
            } else {
                parcialH += "<span class='score empty-service'></span>";
            }

            // Prida game skore
            if (score.Home.game) parcialH += "<span class='score game score-part-" + (++partHomeIndex) + "'>" + score.Home.game + "</span>";

            // Prida parcialne skore (bez predlzeni a penaltov)
            if (score.Home.partially) {
                $.each(score.Home.partially, function (i, partially) {
                    parcialH += "<span class='score partial score-part-" + (++partHomeIndex) + "'>" + partially + "</span>";
                });
            }

            // Prida skore pocas predlzenia
            if (score.Home.overtime) {
                $.each(score.Home.overtime, function (i, partially) {
                    parcialH += "<span class='score overtime score-part-" + (++partHomeIndex) + "'>" + partially + "</span>";
                });
            }

            // Prida skore na penalty
            if (score.Home.penalties) {
                parcialH += "<span class='score penalties score-part-" + (++partHomeIndex) + "'>" + score.Home.penalties + "</span>";
            }

            if (sportID == 54) {
                if (!score.Home.cardsYellow || score.Home.cardsYellow == "0") score.Home.cardsYellow = "-";
                if (!score.Home.cardsRed || score.Home.cardsRed == "0") score.Home.cardsRed = "-";
                if (!score.Home.corners || score.Home.corners == "0") score.Home.corners = "-";
            }

            // Prida zlte a cervene karty (futbal)
            if (score.Home.cardsYellow) {
                parcialH += "<span class='score card-Y score-part-" + (++partHomeIndex) + "'>" + score.Home.cardsYellow + "</span>";
            }
            if (score.Home.cardsRed) {
                parcialH += "<span class='score card-R score-part-" + (++partHomeIndex) + "'>" + score.Home.cardsRed + "</span>";
            }
            if (score.Home.corners) {
                parcialH += "<span class='score corners score-part-" + (++partHomeIndex) + "'>" + score.Home.corners + "</span>";
            }
            return parcialH;
        }
    }
    if (part == "scoreAway") {
        if (score && score.Away) {
            var parcialA = "";
            var partAwayIndex = 0;

            if (score.Away.service) {
                // Prida ikonu ak je aktualne na podani hostujuci team
                parcialA += "<span class='score main-icon ui-icon-sports show-icon sport-icon-" + sportID + " sport-" + sportID + " region-" + regionID + "'></span>";
            } else {
                parcialA += "<span class='score empty-service'></span>";
            }

            // Prida game skore
            if (score.Away.game) parcialA += "<span class='score game score-part-" + (++partAwayIndex) + "'>" + score.Away.game + "</span>";

            // Prida parcialne skore (bez predlzeni a penaltov)
            if (score.Away.partially) {
                $.each(score.Away.partially, function (i, partially) {
                    parcialA += "<span class='score partial score-part-" + (++partAwayIndex) + "'>" + partially + "</span>";
                });
            }

            // Prida skore pocas predlzenia
            if (score.Away.overtime) {
                $.each(score.Away.overtime, function (i, partially) {
                    parcialA += "<span class='score overtime score-part-" + (++partAwayIndex) + "'>" + partially + "</span>";
                });
            }

            // Prida skore na penalty
            if (score.Away.penalties) {
                parcialA += "<span class='score penalties score-part-" + (++partAwayIndex) + "'>" + score.Away.penalties + "</span>";
            }

            if (sportID == 54) {
                if (!score.Away.cardsYellow || score.Away.cardsYellow == "0") score.Away.cardsYellow = "-";
                if (!score.Away.cardsRed || score.Away.cardsRed == "0") score.Away.cardsRed = "-";
                if (!score.Away.corners || score.Away.corners == "0") score.Away.corners = "-";
            }

            // Prida zlte a cervene karty
            if (score.Away.cardsYellow) {
                parcialA += "<span class='score card-Y score-part-" + (++partAwayIndex) + "'>" + score.Away.cardsYellow + "</span>";
            }
            if (score.Away.cardsRed) {
                parcialA += "<span class='score card-R score-part-" + (++partAwayIndex) + "'>" + score.Away.cardsRed + "</span>";
            }
            if (score.Away.corners) {
                parcialA += "<span class='score corners score-part-" + (++partAwayIndex) + "'>" + score.Away.corners + "</span>";
            }
            return parcialA;
        }
    }
  }
};
